import { extractData, extractLinks } from '@/libs/backend/apimapper';
import { HOROSCOPES_ANNUAL_SET_HOROSCOPES, HOROSCOPES_ANNUAL_GET_HOROSCOPES, HOROSCOPES_ANNUAL_LOAD_HOROSCOPES, HOROSCOPES_ANNUAL_CREATE_HOROSCOPE, HOROSCOPES_ANNUAL_DETAIL_HOROSCOPE, HOROSCOPES_ANNUAL_CHANGE_HOROSCOPE } from '@/store/constants';

const state = {
    horoscopeAnnuals: []
};

const actions = {
    [HOROSCOPES_ANNUAL_CHANGE_HOROSCOPE]: async (context, horoscopeAnnualData) => {
        if (!horoscopeAnnualData) {
            return Promise.reject('Incorrect horoscope annual data');
        }
        try {
            const horoscopeAnnual = await context.dispatch('backendTalker', {
                request: 'horoscopeAnnualUpdate',
                data: horoscopeAnnualData
            });
            if (horoscopeAnnual.status === 200) {
                await context.dispatch(HOROSCOPES_ANNUAL_LOAD_HOROSCOPES, {query: '?pagination=true&page=1'});
                return 'changed';
            } else {
                return 'failed';
            }
        } catch (err) {
            return Promise.reject(err);
        }
    },

    [HOROSCOPES_ANNUAL_DETAIL_HOROSCOPE]: async (context, horoscopeAnnualId) => {
        if (!horoscopeAnnualId) {
            return Promise.reject('Incorrect horoscope annual id');
        }
        try {
            const horoscopeAnnual = await context.dispatch('backendTalker', {
                request: 'horoscopeAnnualDetail',
                id: horoscopeAnnualId
            });
            if (!horoscopeAnnual) {
                return Promise.reject('Incorrect horoscope annual data from backend');
            }
            return horoscopeAnnual.data;
        } catch (err) {
            return Promise.reject(err);
        }
    },

    [HOROSCOPES_ANNUAL_CREATE_HOROSCOPE]: async (context, horoscopeAnnualData) => {
        if (!horoscopeAnnualData) {
            return Promise.reject('Incorrect horoscope annual data');
        }
        try {
            const newHoroscopeAnnual = await context.dispatch('backendTalker', {
                request: 'horoscopeAnnualCreate',
                data: horoscopeAnnualData
            });
            if (newHoroscopeAnnual.status === 201) {
                await context.dispatch(HOROSCOPES_ANNUAL_LOAD_HOROSCOPES, {query: '?pagination=true&page=1'});
                return 'created';
            } else {
                return newHoroscopeAnnual.data;
            }
        } catch (err) {
            return Promise.reject(err);
        }
    },

    [HOROSCOPES_ANNUAL_LOAD_HOROSCOPES]: async (context, payload) => {
    const dataToStore = (sourceData) => {
        context.commit(HOROSCOPES_ANNUAL_SET_HOROSCOPES, sourceData);
    };

    try {
        const horoscopeAnnuals = await context.dispatch('backendTalker', {
            request: 'horoscopeAnnualsList',
            query: payload.query
        });

        if (!horoscopeAnnuals) {
            return Promise.reject('Incorrect horoscope annuals data from backend');
        }

        if (payload.metaData) {
            dataToStore(extractData(horoscopeAnnuals.data));
            return extractLinks(horoscopeAnnuals.data)
        } else {
            dataToStore(horoscopeAnnuals.data)
        }
    } catch (err) {
        return Promise.reject(err);
    }
}
};

const mutations = {
    [HOROSCOPES_ANNUAL_SET_HOROSCOPES]: (state, payload) => {
        state.horoscopeAnnuals = payload;
    },
};

const getters = {
    [HOROSCOPES_ANNUAL_GET_HOROSCOPES]: state => state.horoscopeAnnuals,
};

export default {
    state,
    actions,
    mutations,
    getters,
};